import DeviceInfo from '../../DeviceInfo';
export const COMMON_KEYS = {
    ATTRIBUTION: 'attribution',
    MODEL: 'model',
    VERSION: 'platformVersion',
};
export function baseLogBuilder(logObject = {}) {
    return Object.assign({ [COMMON_KEYS.ATTRIBUTION]: '[NO_ATTRIBUTION]' }, logObject);
}
export function initLoggerLogBuilder() {
    return { [COMMON_KEYS.ATTRIBUTION]: '[INIT_LOGGER]' };
}
export function genericTenantLogBuilder(logObject = {}) {
    return Object.assign({ [COMMON_KEYS.ATTRIBUTION]: '[LOG_MODULE]', [COMMON_KEYS.MODEL]: DeviceInfo.getModel(), [COMMON_KEYS.VERSION]: DeviceInfo.getSystemVersion() }, logObject);
}
//# sourceMappingURL=LogBuilders.js.map